// #region imports

// --- Angular
import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

// #endregion

@Directive({
  selector: '[hsDisableControl]'
})
export class DisableControlDirective {

  @Input() set hsDisableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    if (!this.ngControl) {
      return;
    }
    if (!this.ngControl.control) {
      return;
    }
    this.ngControl.control[action]();
  }

  constructor(private ngControl: NgControl ) {
  }
}
